/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddClientRoleMappingsInput } from '../../models/add-client-role-mappings-input';

export interface ApiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Params {
  Authorization?: string;
      body?: AddClientRoleMappingsInput
}

export function apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain.PATH, 'post');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain.PATH = '/api/keycloak/AddAdminClientRoleMappingsToUser';
